module.exports = __webpack_public_path__ + "img/kefu_wx.584d0a7a.png";